import baseEnum from './base-enum'
export let promoSites = Object.assign(
  {},
  {
    Corp: 'corp',
    Vesna: 'vesna',
    Art: 'art',
    Tsarevo: 'tsarevo',
    Vles: 'vles',
    Ub: 'ub'
  },
  {
    name(alias) {
      switch (alias) {
        case this.Corp:
          return 'Корпоративный'

        case this.Vesna:
          return 'Весна 1 очередь'

        case this.Art:
          return 'Арт Сити'

        case this.Tsarevo:
          return 'Царево Village'

        case this.Vles:
          return 'Венский лес'

        case this.Ub:
          return 'Южный бульвар'
      }

      return alias
    }
  },
  baseEnum
)
